import AnalyticsHome from '../components/AnalyticsHome';
import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';

import { checkPermission } from 'utils/credentials';
import { ROLES } from '../../../../consts';

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => {
  return {
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('selectedTab', 'updateSelectedTab', 1),
  withHandlers({
    onChangeTab: props => (evt, value) => {
      props.updateSelectedTab(value);
    },
  }),
  lifecycle({
    async componentDidUpdate(prevProps) {
      checkPermission(this, ROLES.ANALYTICS);
    },
    componentDidMount() {},
  })
);

export default enhance(AnalyticsHome);
